import client from '@common/utils/rest';
import { FORMATS, FormatsActions } from '../const/ActionsConst';
import { getQueriesAsSearch } from '@common/utils';

const URL_PREFIX = 'api/formats';

const FOLDERS_FORMATS_CONFIG = {
    [FORMATS.datasheet.individual]: {
        path: '/ds',
        queries: {
            context: 1,
        }
    },
    [FORMATS.datasheet.pedigree]: {
        path: '/ds',
        queries: {
            context: 2,
        }
    },
    [FORMATS.spreadsheet.individual]: {
        path: '/ss',
        queries: {
            context: 1,
        }
    },
    [FORMATS.subtext]: {
        path: '/subtext',
    },
    [FORMATS.symbols]: {
        path: '/symbols',
    },
    [FORMATS.pedigreeDropFields]: {
        path: '/dropfields',
    },
};

export const getFolderFormats = (type, queries) => (dispatch) => {
    const requestConfig = FOLDERS_FORMATS_CONFIG[type];
    const allQueries = { ...requestConfig.queries, ...queries };
    const path = `${URL_PREFIX}${requestConfig.path}${getQueriesAsSearch(allQueries)}`;

    client({
        path,
        method: 'GET'
    }).then(
        (response) => {
            dispatch({
                type: FormatsActions.SAVE_FOLDER_FORMATS,
                payload: response.entity,
            });
        },
        error => {console.error('getFolderFormats: ', error);}
    );
};

export const clearFolderFormats = () => ({
    type: FormatsActions.CLEAR_FOLDER_FORMATS,
});